import { api, unwrap } from "./httpClient";
import type {
  InvestmentPack,
  PackPurchase,
} from "../types/api";

export interface CreatePackPayload {
  name: string;
  nameEn?: string | null;
  description?: string | null;
  descriptionEn?: string | null;
  totalAmount: number;
  primaryColor?: string | null;
  secondaryColor?: string | null;
  maxPurchases?: number | null;
  benefits?: Array<{
    benefitText: string;
    benefitTextEn?: string | null;
    displayOrder?: number;
  }>;
}

export interface UpdatePackPayload {
  name?: string;
  nameEn?: string | null;
  description?: string | null;
  descriptionEn?: string | null;
  totalAmount?: number;
  primaryColor?: string | null;
  secondaryColor?: string | null;
  maxPurchases?: number | null;
  benefits?: Array<{
    benefitText: string;
    benefitTextEn?: string | null;
    displayOrder?: number;
  }>;
}

export const listPacks = async (options?: {
  limit?: number;
  offset?: number;
}): Promise<InvestmentPack[]> => {
  const params = new URLSearchParams();
  if (options?.limit) {
    params.append("limit", options.limit.toString());
  }
  if (options?.offset) {
    params.append("offset", options.offset.toString());
  }
  
  const url = `/investment-packs${params.toString() ? `?${params.toString()}` : ""}`;
  return unwrap<InvestmentPack[]>(api({ method: "GET", url }));
};

export const getPack = async (packId: number): Promise<InvestmentPack> => {
  return unwrap<InvestmentPack>(
    api({ method: "GET", url: `/investment-packs/${packId}` })
  );
};

export const createPack = async (
  payload: CreatePackPayload
): Promise<InvestmentPack> => {
  return unwrap<InvestmentPack>(
    api({
      method: "POST",
      url: "/investment-packs",
      data: payload,
    })
  );
};

export const updatePack = async (
  packId: number,
  payload: UpdatePackPayload
): Promise<InvestmentPack> => {
  return unwrap<InvestmentPack>(
    api({
      method: "PATCH",
      url: `/investment-packs/${packId}`,
      data: payload,
    })
  );
};

export const deletePack = async (packId: number): Promise<void> => {
  await unwrap(
    api({
      method: "DELETE",
      url: `/investment-packs/${packId}`,
    })
  );
};

export const purchasePack = async (packId: number): Promise<PackPurchase> => {
  return unwrap<PackPurchase>(
    api({
      method: "POST",
      url: `/investment-packs/${packId}/purchase`,
    })
  );
};

export const getUserPackPurchases = async (): Promise<PackPurchase[]> => {
  return unwrap<PackPurchase[]>(
    api({ method: "GET", url: "/investment-packs/user/purchases" })
  );
};

